import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'immutable';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { Text } from 'foundations-components/components/Text';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function TranslateTemplateFooterLinksSection(props) {
  const {
    title,
    values,
    languages
  } = props;
  const footerLinks = values.get(languages[0]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: footerLinks.map((link, idx) => {
      const {
        uuid
      } = link.toJS();
      return /*#__PURE__*/_jsx(AccordionItem, {
        title: /*#__PURE__*/_jsxs(Text, {
          as: "span",
          typography: "heading-100",
          children: [title, " ", `${idx + 1}`]
        }),
        marginBlockStart: "400",
        children: languages.map((lang, langIdx) => {
          const isPrimary = langIdx === 0;
          const languageName = getLanguageNameFromCode(lang);
          const onChange = e => props.onChange(lang, idx, uuid, e);
          const value = values.get(lang, List()).toJS();
          const currItem = value.find(translation => translation.uuid === uuid);
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormControl, {
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.footerLinksFieldLabels.name",
                options: {
                  languageName
                }
              }),
              labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
              }) : null,
              children: /*#__PURE__*/_jsx(TextInput, {
                name: "name",
                onChange: onChange,
                readOnly: isPrimary,
                value: currItem ? currItem.name : ''
              })
            }, uuid), /*#__PURE__*/_jsx(FormControl, {
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.footerLinksFieldLabels.url",
                options: {
                  languageName
                }
              }),
              labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
              }) : null,
              verticalSeparation: "flush",
              children: /*#__PURE__*/_jsx(TextInput, {
                name: "url",
                onChange: onChange,
                readOnly: isPrimary,
                value: currItem ? currItem.url : ''
              })
            }, uuid)]
          });
        })
      }, uuid);
    }).toArray()
  });
}